import React from 'react';
import { useForecast } from '../providers/ForecastProvider';

const ForecastReloadViewWrapper = (props: any) => {
  const { Component } = props;
  const { forecastId, territoryId, forecastCalendarId } = useForecast();
  const componentKey = `${forecastId || 'null'}-${territoryId || 'null'}-${forecastCalendarId || 'null'}`;

  return <Component key={componentKey} />;
};

export default ForecastReloadViewWrapper;
